<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>波次校验</div>
      <el-button
        v-if="openWeight === OPEN_WEIGHT.OPEN"
        type="info"
        style="margin-left: 20px"
        @click="connectDigitalScale"
        >连接电子秤
      </el-button>
    </div>
    <div class="tally-header">
      <div class="input-desk-no">
        <el-button
          :disabled="$store.getters.tallyLock"
          class="c-background"
          style="background-color: rgb(0, 140, 0)"
          @click="deskClick()"
        >
          <span style="color: #fff">&nbsp;工作台</span>
        </el-button>
      </div>
      <div v-if="deskNo" class="desk-no">
        <el-button type="info">{{ deskNo }}</el-button>
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                ref="fromWave"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item label="输入波次号：">
                  <el-input
                    ref="inputRef"
                    v-model="form.wave_picking_no"
                    placeholder="波次号"
                    :disabled="waveNumInputDisabled"
                    @keyup.native.enter="fetchWaveInfo"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="fetchWaveInfo">
                    获取波次信息
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    v-if="waveInfo"
                    type="danger"
                    plain
                    @click="handleExitCheck"
                    >退出校验</el-button
                  >
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" plain @click="overCheck(1)">
                    完成校验
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <span style="color: red">{{
                    waveInfo && waveInfo.prior_tip
                  }}</span>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
      <el-col>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                ref="fromDbid"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item label="输入Dbid：">
                  <el-input
                    ref="inputRefDbid"
                    v-model="form.qrCode"
                    placeholder="dbid=123456"
                    @keyup.native.enter="validateWaveOrder"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    ref="btnRefDbid"
                    type="primary"
                    style="background-color: #f56c6c; color: #fff"
                    @click="validateWaveOrder"
                    >校验</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <audio id="audio_error" preload="auto">
              <source
                src="../../assets/music/check_error.wav"
                type="audio/wav"
              />
            </audio>
            <audio id="audio_success" preload="auto">
              <source
                src="../../assets/music/check_success.wav"
                type="audio/wav"
              />
            </audio>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div v-if="waveInfo" class="data-list" :span="24">
          数据列表：<el-button> 总数：{{ waveInfo.all_num }} </el-button>
          <el-button :type="btnType">
            已校验：{{ waveInfo.all_check_num }}
          </el-button>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="waveInfo && waveInfo.goods.length > 0"
            ref="goodsTable"
            v-loading="tableLoading"
            height="450"
            :data="waveInfo.goods"
            tooltip-effect="dark"
            style="
              width: 59%;
              font-size: 18px !important;
              display: inline-block;
            "
            :cell-class-name="changeCellStyle"
          >
            <el-table-column
              align="center"
              prop="sku"
              label="SKU编号"
            ></el-table-column>
            <el-table-column align="center" label="校验数量">
              <template slot-scope="scope">
                <span
                  >{{ scope.row.dbid_num }}/{{
                    scope.row.wave_picking_info_num
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column align="center" label="打标id">
              <template slot-scope="scope">
                <div @click="toggleHiddenNumbers(scope.row.dbid_join)">
                  <span
                    v-for="(number, index) in displayedNumbers(
                      scope.row.dbid_join
                    )"
                    :key="index"
                  >
                    {{
                      displayedNumbers(scope.row.dbid_join).length > 1
                        ? number + ","
                        : number
                    }}
                  </span>
                  <span v-if="shouldShowMoreNumbers(scope.row.dbid_join)"
                    >...</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="co_val"
              label="颜色"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="si_val"
              label="尺码"
            ></el-table-column>
          </el-table>
          <el-table
            v-if="waveInfo && waveInfo.dbid_exception_list.length > 0"
            ref="exceptionTable"
            v-loading="tableLoading"
            height="450"
            :data="waveInfo.dbid_exception_list"
            tooltip-effect="dark"
            style="
              width: 40%;
              font-size: 18px !important;
              display: inline-block;
            "
            cell-class-name="_red-cell"
          >
            <el-table-column
              align="center"
              prop="serial_number"
              label="序号"
            ></el-table-column>
            <el-table-column align="center" prop="dbid" label="打标id">
            </el-table-column>
            <el-table-column
              prop="goods_img"
              label="图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.goods_img"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="co_val"
              label="颜色"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="exception_msg"
              label="异常原因"
            ></el-table-column>
            <!-- 2023-09-22产品经理（陈庆宇）说先注释掉删除按钮 -->
            <!-- <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="
                    deleteExceptionDbid(
                      scope.row.dbid,
                      scope.row.wave_picking_no
                    )
                  "
                  >删除</el-button
                >
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      ref="dialog"
      :visible.sync="errorMsgDialogVisible"
      width="30%"
      center
    >
      <p style="text-align: center; font-size: 20px">错误提示</p>
      <p style="text-align: center; font-size: 18px; color: red">
        {{ errorMsg }}
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button id="msg" type="button" @click="closeMsgBox">
          知道了
        </el-button>
        <el-button type="button" @click="exitCheck">退出校验</el-button>
      </div>
    </el-dialog>
    <div style="opacity: 1">
      <lodop-print-for-check
        v-if="exPrint"
        :type="type"
        :print-data="mdData"
        @PrintClose="PrintClose"
      ></lodop-print-for-check>
    </div>

    <el-dialog :visible.sync="overCheck_show" width="30%" center>
      <p style="text-align: center; font-size: 20px">完成校验提示</p>
      <p style="text-align: center; font-size: 18px; color: red">
        波次所需{{ diffStockOut_num.need }}, 已校验{{
          diffStockOut_num.finish
        }}; 是否差异出库
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button
          id="msg"
          type="button"
          @click="
            overCheck_show = false;
            $refs.inputRefDbid.$el.children[0].focus();
          "
          >继续校验</el-button
        >
        <el-button type="button" @click="overCheck(0)">完成出库</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="check_one_show"
      width="30%"
      :close-on-click-modal="false"
      center
    >
      <p style="text-align: center; font-size: 16px">波次所需商品为</p>
      <p style="text-align: center; font-size: 48px; color: red">
        {{ check_one_num.all_num }}件
      </p>
      <p style="text-align: center; font-size: 16px">是否一键打包?</p>
      <el-input
        ref="input_enter"
        v-model="saoma_enter.str"
        @keyup.native.enter="checkOneOut"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="button"
          @click="
            check_one_show = false;
            $refs.inputRefDbid.$el.children[0].focus();
          "
          >继续校验</el-button
        >
        <el-button type="button" @click="checkOneOut">一键打包</el-button>
      </div>
    </el-dialog>

    <!-- 一键打包数量校验 -->
    <el-dialog
      :visible.sync="check_one_valid_show"
      width="30%"
      :close-on-click-modal="false"
      center
    >
      <p style="text-align: center; font-size: 16px">一键打包波次所需商品为</p>
      <div
        style="
          font-size: 40px;
          font-weight: 800;
          justify-content: center;
          display: flex;
          margin: auto;
        "
      >
        <input
          ref="input_valid_check_one_num"
          v-model="valid_check_one_num"
          style="
            width: 60px;
            height: 52px;
            font-size: 30px;
            padding: 0 5px;
            margin-right: 10px;
          "
          @keydown.stop="validCheckOneNum"
        />
        <div>件</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="button"
          style="width: 90%; padding: 20px"
          @click="closeValidCheckOneNum"
          >扫码校验</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="check_shipping"
      width="30%"
      :close-on-click-modal="false"
      :show-close="false"
      center
    >
      <p style="text-align: center; font-size: 16px">
        请输入前置打印的快递单号
      </p>
      <div style="justify-content: center; display: flex; margin: auto">
        <el-input
          ref="check_shipping"
          v-model="shipping_num"
          @keyup.native.enter="checkShipping"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="button"
          style="width: 90%; padding: 20px"
          @click="checkShipping"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="check_over_show"
      width="30%"
      :close-on-click-modal="false"
      :show-close="false"
      center
    >
      <div style="text-align: center; font-size: 16px">
        {{ check_over_msg }}
      </div>
      <div>计算（预估）重量：{{ preWeight }}g</div>
      <div>称重重量：{{ currentWeight * 1000 }}g</div>
      <el-input
        ref="over_input_enter"
        v-model="saoma_enter.str"
        @keyup.native.enter="checkCompeleteClose"
        @keyup.native.space="checkCompeleteClose"
      ></el-input>
    </el-dialog>
    <el-dialog
      ref="dialog"
      :visible.sync="isShowExit"
      width="30%"
      center
      title="退出校验"
    >
      <p style="text-align: center; font-size: 18px">
        当前有已扫描校验商品，是否退出校验并生成异常数据
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 40px; width: 20%"
          @click="isShowExit = false"
          >否</el-button
        >
        <el-button type="primary" style="width: 20%" @click="exitCheck"
          >是</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { trimString } from "@/tool/helper.js";
import { cookieCacheSet, cookieCacheGet } from "../../tool/cache.js";
import LodopPrintForCheck from "../../components/LodopPrintForCheck.vue";

const OPEN_WEIGHT = {
  OPEN: "1",
  CLOSED: "2",
};
export default {
  name: "Check1",
  components: { LodopPrintForCheck },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
      // vm.fetchDataCheckSetting();
    });
  },
  data() {
    return {
      isConnecting: false, // 是否连接中
      OPEN_WEIGHT,
      isSupportWeight: false, // 是否支持使用电子秤
      // currentWeight: "", // 电子秤称重重量
      currentWeight: "", // 电子秤称重重量
      preWeight: "",
      weightRate: "",
      openWeight: OPEN_WEIGHT.CLOSED, // 校验称重开关，1开，2关
      exPrint: false,
      type: 0,
      mdData: [],
      waveInfo: null,
      saoma_enter: {
        str: "",
      },
      form: {},
      loading: false,
      print_loading: false,
      tableLoading: false,
      url: "/storage/WavePicking/isChecking",
      status: "",
      curPage: 1,
      filterFold: false,
      websock: null,
      errorMsgDialogVisible: false,
      msgVisibleResource: 1, // 弹窗来源 {1:波次号 2:dbid}
      errorMsg: "",
      deskNo: "",
      checking_sku: "", // 用于判断当前的正在校验中的sku goods_no-co_vall-si_val
      waveNumInputDisabled: false,
      overCheck_show: false,
      check_one_show: false,
      diffStockOut_num: { need: 0, finish: 0 },
      check_one_num: { all_num: 0 },
      check_over_msg: "",
      check_over_show: false,
      check_one_valid_show: false,
      valid_check_one_num: "",
      check_shipping: false,
      shipping_num: "",
      showAllNumbers: false, // 控制是否显示所有数字
      isShowExit: false,
      isChecking: false, // 是否正在校验
      printFlowProcessingCombo: {
        checkFetching: false,
        getWayBillFetching: false,
        rePirntFetching: false,
      }, // 打印流程是否进行中 check -> getWayBill -> rePirnt，如果有一个流程进行中，就不能发起下一个流程
    };
  },
  computed: {
    filteredForm() {
      Object.keys(this.form).forEach((key) => {
        if ([undefined, "", null].includes(this.form[key])) {
          delete this.form[key];
        }
      });
      return this.form;
    },
    btnType() {
      // all_num：这个波次待校验的正常数据
      // check_num：已校验中，本次波次的数量（正常的）
      // all_check_num：已校验：已校验总的数量，包括正常和异常
      const checkNum = parseInt(this.waveInfo.check_num, 10);
      const { all_check_num: allCheckNum, all_num: allNum } = this.waveInfo;
      // 总数等于已校验，没有异常，绿色
      if (allNum === allCheckNum && allNum === checkNum) {
        return "success";
      }
      // 已校验小于总数，没有异常，白色
      if (allCheckNum < allNum && allCheckNum === checkNum) {
        return "";
      }
      // 如果出现异常，红色
      return "danger";
    },
  },
  destroyed() {
    // 页面销毁时关闭长连接
    this.websocketclose();
  },
  created() {
    console.log("波次校验后置单");
    this.isSupportWeight = "serial" in navigator;
    this.initWebSocket();
    this.hasDeskNo();
  },
  methods: {
    async connectDigitalScale() {
      if (!this.isSupportWeight) {
        this.$message.error("当前浏览器不支持连接电子秤");
        return;
      }

      const onDisconnect = () => {
        this.$message.info("电子秤已断开连接");
        this.isConnecting = false;
      };

      const onConnect = async () => {
        this.$message.info("电子秤已连接");
        this.isConnecting = true;
      };

      navigator.serial.addEventListener("disconnect", onDisconnect);
      navigator.serial.addEventListener("connect", onConnect);

      try {
        const port = await navigator.serial.requestPort();
        await port.open({ baudRate: 9600 });
        this.$message.info("电子秤已连接");
        this.isConnecting = true;
        const reader = port.readable.getReader();
        while (true) {
          const { value, done } = await reader.read();
          if (done) {
            reader.releaseLock();
            break;
          }

          let weight = new TextDecoder().decode(value);
          if (weight) {
            weight = weight.trim();
            this.currentWeight = weight.slice(0, -2);
            console.log("实时称重结果", this.currentWeight);
          }
        }
      } catch (error) {
        // Handle errors appropriately
        console.error(error);
      } finally {
        // Clean up event listeners
        navigator.serial.removeEventListener("disconnect", onDisconnect);
        navigator.serial.removeEventListener("connect", onConnect);
      }
    },

    hasDeskNo() {
      this.deskNo = cookieCacheGet("deskNoCheck");
      if (!this.deskNo) {
        this.deskClick();
      }
    },
    // websocket相关
    initWebSocket() {
      // 初始化weosocket

      const ishttps = document.location.protocol === "https:";
      let wsuri;
      if (ishttps) {
        wsuri = "wss://localhost:13529"; // https wss地址
      } else {
        wsuri = "ws://localhost:13528"; // ws地址
      }

      this.websock = new WebSocket(wsuri);
      // this.websocket.onopen = this.websocketonopen;

      this.websock.onerror = this.websocketonerror;

      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonerror() {
      // 错误
    },
    websocketonmessage(e) {
      const obj = JSON.parse(e.data);
      if (obj.cmd === "print") {
        if (obj.status === "failed") {
          this.$confirm(obj.msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        }
      }
    },
    websocketsend(agentData) {
      // 数据发送
      this.websock.send(agentData);
      // 发送完就清空，其它波次校验
      this.form.qrCode = "";
      this.waveNumInputDisabled = false;
      this.form.wave_picking_no = "";
      setTimeout(() => {
        this.$refs.inputRef.$el.children[0].focus();
      }, 200);
    },
    websocketclose() {
      // 关闭
    },
    fetchWaveInfo() {
      // 没有输入波次号就不要提交
      if (!this.form.wave_picking_no.trim()) {
        this.focusInputRef();
        return;
      }

      this.waveNumInputDisabled = true;
      this.$http
        .post("/storage/WavePicking/getWavePickingGoods", this.filteredForm)
        .then((res) => {
          if (res.data.code === 200) {
            this.handleSuccessfulResponse(res);
          } else {
            this.handleErrorResponse(res);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        })
        .finally(() => {
          this.waveNumInputDisabled = false;
        });
    },
    focusInputRef() {
      this.$nextTick(() => {
        this.$refs.inputRef.$el.children[0].focus();
      });
    },
    handleSuccessfulResponse(res) {
      switch (res.data.data.action) {
        case "reCheck":
          this.processReCheck(res);
          break;
        case "printSuccess":
          this.processPrintSuccess();
          break;
        default:
          this.processDefault(res);
          break;
      }
    },
    handleErrorResponse(res) {
      this.errorMsg = res.data.msg;
      this.errorMsgDialogVisible = true;
      this.blurInputRefs();
      this.waveNumInputDisabled = false;
      this.form.wave_picking_no = "";
    },
    blurInputRefs() {
      this.$refs.inputRef.$el.children[0].blur();
      this.$refs.fromWave.$el[1].blur();
    },
    processReCheck(res) {
      this.$confirm(`此波次单已完成校验?`, "", {
        distinguishCancelAndClose: true,
        confirmButtonText: "重新校验",
        cancelButtonText: "获取面单",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/storage/WavePicking/reCheck", {
              wave_picking_no: res.data.data.wave_picking_no,
              wave_picking_id: res.data.data.wave_picking_id,
            })
            .then((resp) => {
              if (resp.data.code === 200) {
                this.form.wave_picking_no = resp.data.data.wave_picking_no;
                this.fetchWaveInfo();
              } else {
                this.showErorrMessage(resp.data.msg);
              }
            });
        })
        .catch((action) => {
          if (action === "cancel") {
            this.printWayBill();
          }
        });
    },
    showErorrMessage(message) {
      this.errorMsg = message;
      this.errorMsgDialogVisible = true;
    },
    processPrintSuccess() {
      const errorMsg = "该波次单已经打印面单";
      this.$alert(errorMsg, "提示", {
        confirmButtonText: "知道了",
        showClose: false,
      });
      this.showErorrMessage(errorMsg);
      this.resetForm();
      this.focusInputRef();
    },
    resetForm() {
      this.form.qrCode = "";
      this.waveNumInputDisabled = false;
      this.form.wave_picking_no = "";
      this.errorMsgDialogVisible = false;
      this.waveInfo = null;
    },
    processDefault(res) {
      const responseData = res.data.data;
      if (this.form.wave_picking_no.includes("dbid")) {
        const { wave_picking_no } = responseData;
        const qrCode = this.form.wave_picking_no;
        this.form = {
          wave_picking_no,
          qrCode,
        };

        this.$refs.inputRefDbid.$el.children[0].focus();
        this.validateWaveOrder();
      } else {
        const { pre_weight, weight_rate, open_weight } = responseData;
        this.$refs.inputRefDbid.$el.children[0].focus();
        this.waveInfo = responseData;
        this.preWeight = pre_weight;
        this.weightRate = weight_rate;
        this.openWeight = open_weight;
        // 如果该波次号需要称重
        if (this.openWeight === this.OPEN_WEIGHT.OPEN) {
          this.checkAndConnectDigitalScale();
        }
      }
    },
    checkAndConnectDigitalScale() {
      // 当前浏览器是否支持称重
      if (this.isSupportWeight) {
        if (!this.isConnecting) {
          this.connectDigitalScale();
        }
      } else {
        this.$message.error("当前浏览器不支持连接电子秤");
      }
    },

    validateWaveOrder() {
      if (this.openWeight === OPEN_WEIGHT.OPEN && !this.isConnecting) {
        this.$message.warning("请连接电子秤");
        return;
      }
      if (!this.deskNo) {
        this.deskClick();
        return;
      }
      this.form.deskNo = this.deskNo;
      if (!this.form.wave_picking_no) {
        this.$message.e("请输入波次单号");
        return;
      }
      if (!this.form.qrCode) {
        this.$message.e("请扫描打标二维码");
        return;
      }
      if (this.isChecking || this.errorMsgDialogVisible) {
        return;
      }
      if (
        this.printFlowProcessingCombo.checkFetching ||
        this.printFlowProcessingCombo.getWayBillFetching ||
        this.printFlowProcessingCombo.rePirntFetching
      ) {
        // 上一个打印流程还没成功，不能发起下一个流程
        return;
      }
      this.isChecking = true;
      this.printFlowProcessingCombo.checkFetching = true;
      this.$http
        .post("/storage/WavePicking/check", this.filteredForm)
        .then(this.handleValidateWaveOrderResponse)
        .catch(this.handleValidateWaveOrderError)
        .finally(() => {
          this.isChecking = false;
          this.printFlowProcessingCombo.checkFetching = false;
        });
    },
    handleValidateWaveOrderResponse(res) {
      this.$set(this.form, "qrCode", "");
      if (res.data.code === 4220) {
        this.getListData(
          {
            wave_picking_no: this.form.wave_picking_no,
          },
          this.handleResponse
        );
      } else if (res.data.code !== 200) {
        this.handleApiErrorCode(res.data.code, res.data.msg);
        if (res.data.code === 400) {
          this.getListData(
            {
              wave_picking_no: this.form.wave_picking_no,
            },
            this.handleResponse
          );
        }
      } else {
        this.handleApiSuccess(res.data.data);
      }
    },
    handleApiErrorCode(code, message) {
      // this.form.qrCode='';
      this.$set(this.form, "qrCode", "");
      this.errorMsg = message;
      this.errorMsgDialogVisible = true;
      this.$refs.inputRefDbid.$el.children[0].blur();
      this.$refs.fromDbid.$el[1].blur();
      this.msgVisibleResource = 2; // 弹窗来源 用于关闭弹窗后focus
      this.addVoice("error");
    },
    handleApiSuccess(data) {
      this.addVoice("success");
      // 触发获取面单
      if (
        data.check_num === data.all_num &&
        data.all_check_num === data.check_num
      ) {
        this.waveInfo = data;
        // 如果已开启称重开关
        if (this.openWeight === OPEN_WEIGHT.OPEN) {
          this.checkCompelete();
        } else if (data.print_status !== "1") {
          // 未打印,获取失败,取消面单的可以打
          this.printWayBill();
        }
      } else {
        // this.form.qrCode='';
        this.$set(this.form, "qrCode", "");
        this.waveInfo = data;
      }
      if (data.checking_sku) {
        this.checking_sku = `${data.checking_sku.goods_no}-${data.checking_sku.co_val}-${data.checking_sku.si_val}`;
      }

      if (this.waveInfo.check_one === 1) {
        this.check_one_num = data;
        this.$set(this.saoma_enter, "str", "");
        if (this.check_one_num.check_one_num_valid === 1) {
          this.check_one_valid_show = true;
          this.$nextTick(() => {
            this.$refs.input_valid_check_one_num.focus();
            this.valid_check_one_num = "";
          });
        } else {
          this.check_one_show = true;
          setTimeout(() => {
            this.$refs.input_enter.$el.children[0].focus();
            this.$refs.input_enter.$el.children[0].select();
          }, 200);
        }
      } else {
        this.$message.success("校验成功");
      }
    },
    handleValidateWaveOrderError(error) {
      console.error(error);
      this.$message.error(error);
    },
    // validateWaveOrder() {
    //   if (this.openWeight === OPEN_WEIGHT.OPEN && !this.isConnecting) {
    //     this.$message.warning("请连接电子秤");
    //     return;
    //   }
    //   if (!this.deskNo) {
    //     this.deskClick();
    //     return;
    //   }
    //   this.form.deskNo = this.deskNo;

    //   if (!this.form.wave_picking_no) {
    //     this.$message.e("请输入波次单号");
    //   }
    //   if (!this.form.qrCode) {
    //     this.$message.e("请扫描打标二维码");
    //   }
    //   this.$http
    //     .post("/storage/WavePicking/check", this.filteredForm)
    //     .then((res) => {
    //       if (res.data.code === 4220) {
    //         this.$set(this.form, "qrCode", "");
    //         const requestData = {
    //           wave_picking_no: this.form.wave_picking_no,
    //         };
    //         this.getListData(requestData, this.handleResponse);
    //       } else if (res.data.code !== 200 && res.data.code !== 4220) {
    //         // this.form.qrCode='';
    //         this.$set(this.form, "qrCode", "");
    //         this.errorMsg = res.data.msg;
    //         this.errorMsgDialogVisible = true;
    //         this.$refs.inputRefDbid.$el.children[0].blur();
    //         this.$refs.fromDbid.$el[1].blur();
    //         this.msgVisibleResource = 2; // 弹窗来源 用于关闭弹窗后focus
    //         this.addVoice("error");
    //         // 弹窗提示后，在异常列表展示原因
    //         if (res.data.code === 400) {
    //           this.$set(this.form, "qrCode", "");
    //           const requestData = {
    //             wave_picking_no: this.form.wave_picking_no,
    //           };
    //           this.getListData(requestData, this.handleResponse);
    //         }
    //       } else {
    //         this.addVoice("success");
    //         // 触发获取面单
    //         if (
    //           res.data.data.check_num === res.data.data.all_num &&
    //           res.data.data.all_check_num === res.data.data.check_num
    //         ) {
    //           this.waveInfo = res.data.data;
    //           // 如果已开启称重开关
    //           if (this.openWeight === OPEN_WEIGHT.OPEN) {
    //             this.checkCompelete();
    //           } else if (res.data.data.print_status !== "1") {
    //             // 未打印,获取失败,取消面单的可以打
    //             this.printWayBill();
    //           }
    //         } else {
    //           // this.form.qrCode='';
    //           this.$set(this.form, "qrCode", "");
    //           this.waveInfo = res.data.data;
    //         }
    //         if (res.data.data.checking_sku) {
    //           this.checking_sku = `${res.data.data.checking_sku.goods_no}-${res.data.data.checking_sku.co_val}-${res.data.data.checking_sku.si_val}`;
    //         }

    //         if (this.waveInfo.check_one === 1) {
    //           this.check_one_num = res.data.data;
    //           this.$set(this.saoma_enter, "str", "");
    //           if (this.check_one_num.check_one_num_valid === 1) {
    //             this.check_one_valid_show = true;
    //             this.$nextTick(() => {
    //               this.$refs.input_valid_check_one_num.focus();
    //               this.valid_check_one_num = "";
    //             });
    //           } else {
    //             this.check_one_show = true;
    //             setTimeout(() => {
    //               this.$refs.input_enter.$el.children[0].focus();
    //               this.$refs.input_enter.$el.children[0].select();
    //             }, 200);
    //           }
    //         } else {
    //           this.$message.success("校验成功");
    //         }
    //       }
    //     });
    // },
    checkOneOut() {
      if (this.saoma_enter.str !== "") {
        if (this.saoma_enter.str !== "enter") {
          this.$set(this.saoma_enter, "str", "");
          this.$message.e("提交二维码有误.");
          return;
        }
      }
      this.$set(this.saoma_enter, "str", "");
      this.$http
        .post("/storage/WavePicking/checkOneOut", this.filteredForm)
        .then((res) => {
          if (res.data.code === 200) {
            this.waveInfo = res.data.data;
            // 未打印,获取失败,取消面单的可以打
            if (`${res.data.data.print_status}` !== "1") {
              this.printWayBill(1);
              this.$refs.inputRef.$el.children[0].focus();
              this.check_one_show = false;
            }
          } else {
            this.errorMsg = res.data.msg;
            this.errorMsgDialogVisible = true;
          }
        });
    },

    validCheckOneNum($e) {
      if ($e.key !== "Enter") {
        return false;
      }
      // 如果有输入数量 则enter是一件打包
      if (this.valid_check_one_num) {
        if (!/^\d+$/.test(this.valid_check_one_num)) {
          return this.$message.e("请输入数量");
        }
        // 验证数量是否正确
        if (this.valid_check_one_num === this.check_one_num.all_num) {
          this.saoma_enter.str = "enter"; // 给下面的方法用
          this.checkOneOut();
          this.closeValidCheckOneNum(); // 关闭弹窗
          return false;
        }
        this.$confirm("商品数量错误, 请扫码校验", {
          closeOnClickModal: false,
          showCancelButton: false,
          showClose: false,
        })
          .then(() => {
            return this.closeValidCheckOneNum();
          })
          .catch(() => {
            return this.closeValidCheckOneNum();
          });
        return false;
      }
      // 为空则继续扫码校验
      this.closeValidCheckOneNum();
      return false;
    },
    // 关闭数量校验
    closeValidCheckOneNum() {
      setTimeout(() => {
        this.check_one_valid_show = false;
        this.$refs.inputRefDbid.focus();
      }, 100);
      return false;
    },

    checkCompeleteClose() {
      if (this.openWeight === OPEN_WEIGHT.OPEN) {
        if (!this.currentWeight) {
          this.$message.error("包裹请称重");
          return;
        }
      }
      if (this.saoma_enter.str.trim() !== "") {
        if (this.saoma_enter.str.trim() !== "enter") {
          this.$set(this.saoma_enter, "str", "");
          this.$message.e("提交二维码有误.");
          return;
        }
      }
      this.$set(this.saoma_enter, "str", "");
      this.check_over_msg = "";
      this.check_over_show = false;
      this.$refs.inputRef.$el.children[0].focus();
      if (this.openWeight === OPEN_WEIGHT.OPEN) {
        const diffValue = Math.abs(
          Number(this.currentWeight) * 1000 - Number(this.preWeight)
        );
        console.log("diffValue", diffValue);
        const rate = diffValue / Number(this.preWeight);
        console.log("计算的rate", rate);
        console.log("weightRate", Number(this.weightRate) / 100);
        console.log("是否超过", rate > Number(this.weightRate) / 100);
        if (rate > Number(this.weightRate) / 100) {
          this.$confirm("称重异常，请重新称重", "提示", {
            confirmButtonText: "坚定提交",
            showCancelButton: false,
            type: "warning",
          }).then(() => {
            this.printWayBill();
          });
        } else {
          this.printWayBill();
        }
      }
    },
    // 校验完成之后的提示
    checkCompelete() {
      // 当开启称重且只有一件时，不需要弹框回车确认
      if (this.waveInfo.all_num === 1 && this.openWeight !== OPEN_WEIGHT.OPEN) {
        return;
      }
      this.$set(this.saoma_enter, "str", "");
      this.$refs.inputRefDbid.$el.children[0].blur();
      this.check_over_msg = `校验已完成，共${this.waveInfo.check_num}件`;
      this.check_over_show = true;
      setTimeout(() => {
        this.$refs.over_input_enter.$el.children[0].focus();
        this.$refs.over_input_enter.$el.children[0].select();
      }, 500);
    },
    addVoice(t) {
      document.getElementById(`audio_${t}`).play();
    },
    handleExitCheck() {
      if (this.waveInfo.all_num > 0) {
        this.isShowExit = true;
      }
    },
    // 退出校验
    exitCheck() {
      if (this.isShowExit) {
        this.form.deskNo = this.deskNo;
      }
      this.$http
        .post("/storage/WavePicking/exitCheck", this.filteredForm)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg);
            this.form.qrCode = "";
            this.form.wave_picking_no = "";
            this.form.deskNo = "";
            this.errorMsgDialogVisible = false;
            this.waveInfo = null;
            this.waveNumInputDisabled = false;
            this.check_one_show = false;
            setTimeout(() => {
              this.$refs.inputRef.$el.children[0].focus();
            }, 200);
          } else {
            this.errorMsg = res.data.msg;
            this.errorMsgDialogVisible = true;
          }
        });
      this.isShowExit = false;
    },
    printWayBill(checkOne = 0) {
      this.printFlowProcessingCombo.getWayBillFetching = true;
      // 获取面单
      this.$http
        .post("/storage/WavePicking/getWayBill", {
          ...this.filteredForm,
          weight: Number(this.currentWeight) * 1000,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            if (`${res.data.msg}` === "400" || `${res.data.msg}` === "402") {
              this.$confirm(
                `调用菜鸟接口出错，请检查菜鸟后台是否已绑定了此快递以及余额是否大于0，或重新获取面单。`,
                "",
                {
                  confirmButtonText: "重新获取",
                  cancelButtonText: "校验其它",
                  type: "warning",
                }
              )
                .then(() => {
                  this.printWayBill();
                })
                .catch(() => {
                  // this.form.qrCode='';
                  this.$set(this.form, "qrCode", "");
                  this.waveNumInputDisabled = false;
                  this.form.wave_picking_no = "";
                  setTimeout(() => {
                    this.$refs.inputRef.$el.children[0].focus();
                  }, 200);
                });
            } else {
              this.errorMsg = res.data.msg;
              this.errorMsgDialogVisible = true;
            }
          } else if (`${res.data.data.print_status}` === "1") {
            this.printFlowProcessingCombo.rePirntFetching = true;
            // 打印面单
            this.$http
              .post("/erp/WavePicking/rePirnt", {
                wave_picking_no: res.data.data.wave_picking_no,
              })
              .then((resp) => {
                if (resp.data.code !== 200) {
                  this.errorMsg = resp.data.msg;
                  this.errorMsgDialogVisible = true;
                } else {
                  // websock打印
                  this.websocketsend(JSON.stringify(resp.data.data.printData));
                  if (this.openWeight === OPEN_WEIGHT.OPEN) {
                    // 校验完成之后关闭校验弹框
                    this.check_over_show = false;
                    this.currentWeight = "";
                  }
                }
              })
              .finally(() => {
                this.printFlowProcessingCombo.rePirntFetching = false;
              });
            // 打印配货单
            this.printBill(res.data.data.wave_picking_no);
            // 校验完成之后的提
            if (checkOne === 0) {
              this.checkCompelete();
            }
          } else if (
            `${res.data.data.print_status}` === "5" ||
            `${res.data.data.print_status}` === "4" ||
            `${res.data.data.print_status}` === "6"
          ) {
            // 弹出校验快递单号
            this.check_shipping = true;
            this.shipping_num = "";
            this.$nextTick(() => {
              this.$refs.check_shipping.focus();
            });
          }
        })
        .finally(() => {
          this.printFlowProcessingCombo.getWayBillFetching = false;
        });
    },
    fetchData(showLoading) {
      this.deskNo = cookieCacheGet("deskNoCheck");
      this.$refs.inputRef.$el.children[0].focus();
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (typeof res.data.data.wave_picking_no !== "undefined") {
          this.$confirm(
            `您有正在校验的波次(${res.data.data.wave_picking_no})，是否继续?`,
            "",
            {
              confirmButtonText: "继续校验",
              cancelButtonText: "退出校验",
              type: "warning",
            }
          )
            .then(() => {
              const requestData = {
                wave_picking_no: res.data?.data?.wave_picking_no,
              };
              this.getListData(requestData, this.handleResponse);
            })
            .catch(() => {
              this.$http
                .post("/storage/WavePicking/exitCheck", {
                  wave_picking_no: res?.data?.data?.wave_picking_no,
                })
                .then((resp) => {
                  if (resp.data.code === 200) {
                    this.$refs.inputRef.$el.children[0].focus();
                    this.$message.success(resp.data.msg);
                  } else {
                    this.errorMsg = resp.data.msg;
                    this.errorMsgDialogVisible = true;
                  }
                });
            });
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      let dbid = "";
      if (typeof this.form.dbid !== "undefined") {
        dbid = this.form.dbid.split("dbid=");
      }

      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (
          typeof this.form.dbid !== "undefined" &&
          typeof dbid[1] !== "undefined"
        ) {
          this.form.dbid = dbid[1];
        }
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
          this.waveInfo = [];
        } else {
          this.waveInfo = res.data.data;
        }
      });
    },
    deskClick() {
      this.$prompt("", "工作台", {
        confirmButtonText: "确定",
      })
        .then(({ value }) => {
          this.verifyDeskNo(value);
        })
        .catch(() => {
          if (!this.deskNo) {
            this.deskClick();
          }
        });
    },
    verifyDeskNo(value) {
      const val = trimString(value);
      if (!val) {
        this.deskClick();
        this.$message.e("请输入工作台号");
      }
      if (Object.keys(val).length !== 8) {
        this.deskClick();
        this.$message.e("工作台号码有误,请检查");
      }
      this.$http
        .post("/erp/Tally/verifyDeskNo", { desk_no: val })
        .then((res) => {
          if (`${res.data.code}` !== "200") {
            this.deskClick();
            this.$message.e(res.data.msg);
          }
          cookieCacheSet("deskNoCheck", val, 64800);
          this.deskNo = val;
        });
    },
    PrintClose() {
      this.exPrint = false;
      this.mdData = [];
    },
    printBill(value) {
      if (`${this.waveInfo?.all_num}` === "1") {
        console.log("单件波次不打印配货单");
        return;
      }

      if (`${this.waveInfo.is_put_picking_list}` === "1") {
        this.$http
          .post("/erp/WavePicking/printWavePickingBill", {
            param: value,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
            const { data } = res.data;
            const note = 0;
            const { origin } = data;
            if (data.asSummryId.length > 0) {
              const params = {
                delNum: 0,
                wave_picking_info_id: 0,
                multipleSelection: data.asSummryId.join(","),
                note,
                origin,
              };
              this.$http
                .post("/erp/AsWavePicking/getPrintWavePickingList", params)
                .then((resp) => {
                  if (`${resp.data.code}` !== "200") {
                    this.$message.error(resp.data.msg);
                  }
                  this.type = 4;
                  this.mdData = resp.data.data.list;
                  this.exPrint = true;
                });
              return;
            }
            // 常规
            if (data.norSummaryId.length > 0) {
              const params = {
                delNum: 0,
                wave_picking_info_id: 0,
                multipleSelection: data.norSummaryId.join(","),
                note,
                origin,
              };
              this.$http
                .post("/erp/WavePicking/getPrintWavePickingList", params)
                .then((resp) => {
                  if (`${resp.data.code}` !== "200") {
                    this.$message.error(resp.data.msg);
                  }
                  this.type = 0;
                  this.mdData = resp.data.data.list;
                  this.exPrint = true;
                });
            }
          });
      } else {
        this.msgVisibleResource = 1;
        this.errorMsg = "该波次为不放发货单波次";
        this.errorMsgDialogVisible = true;
      }
    },

    closeMsgBox() {
      this.errorMsgDialogVisible = false;
      if (`${this.msgVisibleResource}` === "2") {
        this.$refs.inputRefDbid.$el.children[0].focus();
      } else {
        this.$refs.inputRef.$el.children[0].focus();
      }
    },
    changeCellStyle({ row }) {
      // row.dbid_num < row.wave_picking_info_num) = red
      // row.dbid_num < row.wave_picking_info_num && sku = this.checking_sku) = yellow
      if (row.dbid_num === row.wave_picking_info_num) {
        // 校验完成
        return "success-cell";
      }
      // this.checking_sku = `${row.goods_no}-${row.co_val}-${row.si_val}`;
      if (row.dbid_num > 0 && row.dbid_num < row.wave_picking_info_num) {
        if (this.checking_sku === `${row.goods_no}-${row.co_val}-${row.si_val}`)
          return "_yellow-cell";
        return "_red-cell";
      }

      return "";
    },
    // 获取校验设置
    fetchDataCheckSetting() {
      this.$http
        .post("/erp/WavePicking/WavePickingCheckSettingGet")
        .then((rs) => {
          this.checkSetting = rs.data.data;
        })
        .catch(() => {
          this.$message.e("获取校验设置失败, 请刷新页面或者联系技术人员");
        });
    },

    // 完成校验 -- 差异出库
    overCheck(isCheck) {
      const { wave_picking_no: wavePickingNo } = this.form;
      if (!wavePickingNo) return;
      this.$http
        .post("/erp/WavePicking/wavePickingDiffStockout", {
          wave_picking_no: wavePickingNo,
          isCheck,
        })
        .then((rs) => {
          if (`${rs.data.code}` !== "200") this.$message.e(rs.data.msg);
          if (isCheck === 1) {
            this.overCheck_show = true;
            this.diffStockOut_num = rs.data.data;
            return;
          }
          this.overCheck_show = false;
          this.$message.success("已完成校验");
          const { data } = rs.data;
          // 打印面单
          if (`${data.print_status}` !== "1") {
            this.printWayBill();
          } else {
            this.form.qrCode = "";
            this.form.wave_picking_no = "";
            this.waveNumInputDisabled = false;
            setTimeout(() => {
              this.$refs.inputRef.$el.children[0].focus();
            }, 200);
          }
        });
    },
    checkShipping() {
      this.$http
        .post("/storage/WavePicking/checkShipping", {
          wave_picking_no: this.form.wave_picking_no,
          shipping_num: this.shipping_num,
        })
        .then((rs) => {
          if (`${rs.data.code}` !== "200") {
            this.$message.error(rs.data.msg);
          }
          if (rs.data.data.msg) {
            this.errorMsg = rs.data.data.msg;
            this.errorMsgDialogVisible = true;
            this.msgVisibleResource = 1;
          } else {
            this.$message.success("已完成校验");
          }
          this.check_shipping = false;
          this.$set(this.form, "qrCode", "");
          this.$set(this.form, "wave_picking_no", "");
          this.waveInfo = null;
          this.waveNumInputDisabled = false;
          setTimeout(() => {
            this.$refs.inputRef.$el.children[0].focus();
          }, 200);
        });
    },
    toggleHiddenNumbers() {
      // 在点击时，显示或隐藏剩余的数字
      this.$set(this, "showAllNumbers", !this.showAllNumbers);
    },
    displayedNumbers(joinedDbIds) {
      if (!joinedDbIds) {
        return [];
      }
      const numbers = joinedDbIds.split(",");
      return this.showAllNumbers ? numbers : numbers.slice(0, 5);
    },
    shouldShowMoreNumbers(joinedDbIds) {
      // 检查是否有更多的数字需要显示
      return joinedDbIds?.split(",").length > 5 && !this.showAllNumbers;
    },
    // 2023-09-22产品经理（陈庆宇）说先注释掉删除按钮
    // deleteExceptionDbid(dbid, wavePickingNo) {
    //   const params = { dbid, wave_picking_no: wavePickingNo };
    //   this.$http
    //     .post("/erp/WavePickingInfo/delExceptionDbid", params)
    //     .then((res) => {
    //       if (res.data.code === 200) {
    //         //  重新调接口获取信息
    //         const requestData = {
    //           wave_picking_no: this.form.wave_picking_no,
    //         };
    //         this.getListData(requestData, this.handleResponse);
    //       }
    //     })
    //     .catch((error) => {
    //       console.error(`删除异常时出错：${error}`);
    //     });
    // },
    getListData(requestData, responseHandler) {
      // 确保 wave_picking_no exists 存在.
      if (!requestData.wave_picking_no) {
        console.error("Wave picking number is missing.");
        return;
      }
      this.$http
        .post("/storage/WavePicking/getWavePickingGoods", requestData)
        .then((resp) => {
          responseHandler.call(this, resp);
        })
        .catch((error) => {
          console.error("获取数据列表出错:", error);
        });
    },
    handleResponse(response) {
      if (response.data.code === 200) {
        const checkNum = parseInt(response.data.data.check_num, 10);
        const { all_check_num: allCheckNum, all_num: allNum } =
          response.data.data;
        if (allNum > 0 && checkNum === allCheckNum && checkNum === allNum) {
          this.printWayBill();
        }
        this.waveNumInputDisabled = true;
        this.form.wave_picking_no = response?.data?.data.wave_picking_no;
        this.$refs.inputRefDbid.$el.children[0].focus();
        this.waveInfo = response?.data?.data;
      } else {
        this.errorMsg = response.data.msg;
        this.errorMsgDialogVisible = true;
      }
    },
  },
};
</script>
<style>
.success-cell {
  background-color: #cbefba !important;

  /* background: #cbefba!important; */
}

._red-cell {
  background-color: #ff8383 !important;
}

._yellow-cell {
  background-color: yellow !important;
}
</style>

<style scoped>
.row {
  height: 60px;
}

.tally-header {
  padding-top: 10px;
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.data-list {
  background: #f3f3f3;
  height: 44px;
  line-height: 42px;
  padding: 0 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/Check1.vue